import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37b50053"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "listing-tokens-container" }
const _hoisted_2 = { class: "mb-3 row d-flex align-items-center flex-nowrap" }
const _hoisted_3 = { class: "col-10" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "list-group-container my-3" }
const _hoisted_7 = { class: "list-group-item text-left d-flex align-items-center flex-nowrap" }
const _hoisted_8 = { class: "col-8" }
const _hoisted_9 = { style: {"margin-bottom":"0px","white-space":"nowrap"} }
const _hoisted_10 = { class: "col-4" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "list-group-item text-left" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  class: "modal fade",
  tabindex: "-1",
  id: "editToken_modal"
}
const _hoisted_19 = { class: "modal-dialog" }
const _hoisted_20 = { class: "modal-content" }
const _hoisted_21 = { class: "modal-header" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Edit Prompt", -1))
const _hoisted_23 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, null, -1))
const _hoisted_25 = {
  class: "modal fade",
  tabindex: "-1",
  id: "addToken_modal"
}
const _hoisted_26 = { class: "modal-dialog" }
const _hoisted_27 = { class: "modal-content" }
const _hoisted_28 = { class: "modal-header" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Add Prompt", -1))
const _hoisted_30 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, null, -1))
const _hoisted_32 = {
  class: "modal fade",
  tabindex: "-1",
  id: "deleteToken_modal"
}
const _hoisted_33 = { class: "modal-dialog" }
const _hoisted_34 = { class: "modal-content" }
const _hoisted_35 = { class: "modal-header" }
const _hoisted_36 = {
  key: 0,
  class: "modal-title"
}
const _hoisted_37 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, null, -1))
const _hoisted_39 = { class: "modal-body" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "modal-footer" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Cancel ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_EditToken = _resolveComponent("EditToken")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control token-search",
            placeholder: "Search for a prompt",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tokenfilter) = $event)),
            disabled: !_ctx.filterSearch
          }, null, 8, _hoisted_4), [
            [_vModelText, _ctx.tokenfilter]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("i", {
            class: "fas fa-plus customPlusIcon",
            title: "Add Prompt",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addToken()))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterSearch ? _ctx.filteredTokens : _ctx.tokens, (token) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "list-group",
            key: token.name
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h5", _hoisted_9, _toDisplayString(token.name), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("i", {
                  class: "fas fa-trash customTrashIcon",
                  title: "Remove Prompt",
                  onClick: ($event: any) => (_ctx.confirmTokenDeletion(token))
                }, null, 8, _hoisted_11),
                _createElementVNode("i", {
                  class: "fa-solid fa-pen m-2 customEditIcon",
                  title: "Edit Prompt",
                  onClick: ($event: any) => (_ctx.changeSelectedToken(token))
                }, null, 8, _hoisted_12),
                _createElementVNode("i", {
                  class: "text-start fa-solid fa-plus m-2 customAddIcon",
                  title: "Add Prompt",
                  onClick: ($event: any) => (this.$parent.selectPrompt(token.name, token.type))
                }, null, 8, _hoisted_13)
              ])
            ])
          ])), [
            [_vShow, _ctx.filterSearch]
          ])
        }), 128)),
        (!_ctx.filterSearch)
          ? (_openBlock(), _createBlock(_component_draggable, {
              key: 0,
              list: _ctx.tokens,
              disabled: false,
              "item-key": "name",
              class: "list-group col",
              "ghost-class": "ghost",
              move: _ctx.checkMove,
              onStart: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dragging = true)),
              onEnd: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dragging = false))
            }, {
              item: _withCtx(({ element }) => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    class: "customBtn",
                    onClick: ($event: any) => (this.$parent.selectPrompt(element.name, element.type))
                  }, _toDisplayString(element.name), 9, _hoisted_15),
                  _createElementVNode("i", {
                    class: "fas fa-trash customTrashIcon",
                    title: "Remove Prompt",
                    onClick: ($event: any) => (_ctx.confirmTokenDeletion(element))
                  }, null, 8, _hoisted_16),
                  _createElementVNode("i", {
                    class: "fas fa-edit m-2 customEditIcon",
                    title: "Edit Prompt",
                    onClick: ($event: any) => (_ctx.changeSelectedToken(element))
                  }, null, 8, _hoisted_17)
                ])
              ]),
              _: 1
            }, 8, ["list", "move"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
            ])
          ]),
          (_ctx.editTokenModalObject && _ctx.tokens)
            ? (_openBlock(), _createBlock(_component_EditToken, {
                key: 0,
                selectedToken: _ctx.editTokenModalObject,
                "onUpdate:selectedToken": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editTokenModalObject) = $event)),
                tokens: _ctx.tokens,
                tokensTypes: _ctx.tokenTypes,
                onCloseEditTokenForm: _ctx.closeEditTokenForm,
                onEditedTokenSuccessfully: _ctx.editedTokenSuccessfully
              }, null, 8, ["selectedToken", "tokens", "tokensTypes", "onCloseEditTokenForm", "onEditedTokenSuccessfully"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
            ])
          ]),
          (_ctx.addTokenVisible && _ctx.tokens)
            ? (_openBlock(), _createBlock(_component_EditToken, {
                key: 0,
                selectedToken: null,
                tokens: _ctx.tokens,
                tokensTypes: _ctx.tokenTypes,
                onCloseEditTokenForm: _ctx.closeEditTokenForm,
                onEditedTokenSuccessfully: _ctx.editedTokenSuccessfully
              }, null, 8, ["tokens", "tokensTypes", "onCloseEditTokenForm", "onEditedTokenSuccessfully"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            (_ctx.tokenToDelete)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_36, " Delete Prompt " + _toDisplayString(_ctx.tokenToDelete.name), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            (_ctx.tokenToDelete)
              ? (_openBlock(), _createElementBlock("p", _hoisted_40, " Are you sure you want to delete token " + _toDisplayString(_ctx.tokenToDelete.name) + "? ", 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            (_ctx.tokenToDelete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-danger",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteToken(_ctx.tokenToDelete.tokenId)))
                }, " Delete "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}